import { render, staticRenderFns } from "./TuBianji.vue?vue&type=template&id=0910c00e&"
import script from "./TuBianji.vue?vue&type=script&lang=js&"
export * from "./TuBianji.vue?vue&type=script&lang=js&"
import style0 from "./TuBianji.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports